export default __webpack_public_path__ + "static/media/39.33d507d2.png";